module.exports = __webpack_public_path__ + "static/img/微信图片_20210120095641.5b213ca8.jpg";